<template>
    <el-main
        class="el_main_container"
        style="
            padding: 20px 20px 42px 20px;
            background-color: #ffffff;
            height: calc(100vh - 60px);
            overflow-y: auto;
        "
    >
        <div class="pro_container">
            <global-tag>
                <span slot="title">产品管理</span>
                <div class="search" slot="search">
                    <el-form label-width="100px">
                        <el-row>
                            <el-col :span="5">
                                <el-form-item label="产品名称：">
                                    <el-input
                                        v-model="productName"
                                        placeholder="请输入产品名称"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5" :offset="4">
                                <el-button
                                    type="primary"
                                    class="searchBtns"
                                    @click="search"
                                    >搜索</el-button
                                >
                                <el-button
                                    type="info"
                                   class="resetReach"
                                    @click="handleReset"
                                    >重置</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </global-tag>
            <div class="table_title" style="margin: 24px 0">
                <el-button
                    type="success"
                    icon="el-icon-plus"
            class="openBtns"
                    @click="handleTableForm('新增')"
                    >新增</el-button
                >
            </div>
            <!-- tableb表格 -->
            <div class="table_container">
                <el-table
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    height="550px"
                    :header-cell-style="{
                        background: '#e6e6e6',
                        color: '#000',
                    }"
                    border
                >
                    <el-table-column
                        width="80"
                        align="center"
                        label="序号"
                        type="index"
                        v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '序号'
                            ) != -1
                        "
                    >
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="产品名称"
                        prop="productName"
                        v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '产品名称'
                            ) != -1
                        "
                    >
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="内部采购价"
                        prop="internalPurchasePrice"
                        v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '内部采购价'
                            ) != -1
                        "
                    >
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                        width="140px"
                        v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '操作'
                            ) != -1
                        "
                    >
                        <template slot-scope="scope">
                            <el-tooltip
                                effect="dark"
                                content="编辑"
                                placement="top-start"
                            >
                                <img
                                    src="../../assets/img/table_edit.png"
                                    @click="handleTableForm('编辑', scope.row)"
                                    style="margin-left: 12px; cursor: pointer"
                                />
                            </el-tooltip>
                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="删除"
                                placement="top-start"
                            >
                                <img
                                    src="../../assets/img/table_delete.png"
                                    @click="handleDelete(scope.row)"
                                    style="margin-left: 12px; cursor: pointer"
                                />
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination_container">
                <el-pagination
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-size="pageSize"
                    :total="total"
                    :current-page.sync="pageNo"
                    @size-change="handletableDataSize"
                    @current-change="handleTableDataChange"
                ></el-pagination>
            </div>
            <el-dialog
                :title="dialogVisibleTitle"
                :visible.sync="dialogVisible"
                width="40%"
                class="dialog_container"
                @close="dialogVisibleClone"
            >
                <div class="dialog_content">
                    <el-form
                        label-width="120px"
                        :model="formData"
                        :rules="formDataRules"
                        ref="formData"
                    >
                        <el-form-item label="产品名称：" prop="productName">
                            <el-input
                                v-model.trim="formData.productName"
                                placeholder="请输入产品名称"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="内部采购价："
                            prop="internalPurchasePrice"
                        >
                            <el-input
                                v-model.number="formData.internalPurchasePrice"
                                type="number"
                                placeholder="内部采购价"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="handleSubmit"
                        >确 定</el-button
                    >
                    <el-button @click="dialogVisibleClone">取 消</el-button>
                </span>
            </el-dialog>
        </div>
    </el-main>
</template>

<script>
import globalTag from "../../components/globalTag"
export default {
    name: "AddressManagement",
    data() {
        return {
            projectName: "", //项目名称
            productName: "", //产品名称
            pageSize: 10,
            pageNo: 1,
            total: 0,
            formData: {
                internalPurchasePrice: "", //内部采购价
                productName: "", //产品名称
                qujiId: "",
                shengjiId: "",
                shijiId: "",
                stationId: "",
            },
            formDataRules: {
                internalPurchasePrice: [
                    {
                        type: "number",
                        message: "采购价必须为数字值",
                        trigger: "blur",
                    },
                    {
                        required: true,
                        message: "采购价不能为空",
                        trigger: "blur",
                    },
                ],
                productName: [{ required: true, message: "产品名称不能为空" }],
            },
            tempTableChekbox: ["序号", "产品名称", "内部采购价", "操作"],
            tableChekbox: ["序号", "产品名称", "内部采购价", "操作"],
            tableData: [
                // tabble数据
            ],
            dialogVisible: false, //table表单弹窗
            dialogVisibleTitle: "", //table表单弹窗title
        }
    },
    components: {
        globalTag,
    },
    created() {
        this.getFindList()
    },

    methods: {
        search() {
            this.getFindList()
        },
        handleDelete(row) {
            this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .request({
                            url: "/ypt/admin/productManage/info/delete",
                            method: "POST",
                            data: {
                                id: row.id,
                            },
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                this.$message.success("删除成功")
                            } else if (res.code == "10004") {
                                this.$message.error(res.message)
                                this.$router.push("/login")
                            } else {
                                this.$message.error("删除失败")
                            }
                            this.getFindList()
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    })
                })
        },
        //获取表格数据
        getFindList() {
            this.$http
                .request({
                    url: "/ypt/admin/productManage/info/findList",
                    method: "POST",
                    data: {
                        pageSize: this.pageSize,
                        pageNo: this.pageNo,
                        productName: this.productName,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.total = res.content.count
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        handleSubmit() {
            let url = ""
            if (this.formData.id) {
                url = "/ypt/admin/productManage/info/modify"
            } else {
                url = "/ypt/admin/productManage/info/add"
            }
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.$http
                        .request({
                            url: url,
                            method: "POST",
                            data: this.formData,
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.message)
                                this.getFindList()
                            } else if (res.code == "10004") {
                                this.$message.error(res.message)
                                this.$router.push("/login")
                            } else {
                                this.$message.error("保存失败")
                            }
                            this.dialogVisible = false
                        })
                } else {
                    console.log("error submit!!")
                    return false
                }
            })
        },
        //清除搜索条件
        handleReset() {
            this.pageSize = 10
            this.pageNo = 1
            this.productName = ""
            this.getFindList()
        },
        handleTableForm(title, row) {
            this.dialogVisible = true
            this.dialogVisibleTitle = title
            if (title == "编辑") {
                this.formData.productName = row.productName
                this.formData.internalPurchasePrice = row.internalPurchasePrice
                this.formData.id = row.id
            }
        },
        // 页面刷新
        Reset() {
            this.reload()
        },
        //table列checkbox发生变化
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //table表格表单弹窗关闭时事件
        dialogVisibleClone() {
            this.$refs.formData.resetFields()
            // this.$emit('handleClose')
            this.dialogVisible = false
            this.formData.productName = ""
            this.formData.internalPurchasePrice = ""
            delete this.formData.id
            // this.getFindList()
        },
        //老人信息列表pagesize发生改变
        handletableDataSize(val) {
            this.pageSize = val
            this.getFindList()
        },
        //老人信息列表页码发生改变
        handleTableDataChange(val) {
            this.pageNo = val
            this.getFindList()
        },
    },
}
</script>

<style lang="less" scoped>
/deep/ .dialog_container {
    .el-dialog__header {
        border-bottom: 1px solid #e5e5e5;
    }
    .el-dialog__body {
        padding-left: 60px;
        padding-right: 60px;
    }
    .dialog_content {
        .el-col {
            text-align: center;
        }
        .el-select {
            .el-input__inner {
                width: 100%;
            }
        }
        .table_add_wraoper {
            .add_table {
                margin-top: 24px;
            }
        }
    }
    .el-dialog__footer {
        background: #f5f5f5;
        padding: 8px 15px;
        border-top: 1px solid #e5e5e5;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
}
.table_container {
    width: 100%;
}
.pagination_container {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}
/deep/ .el_main_container {
    padding: 20px 20px 42px 20px !important;
    background-color: #ffffff !important;
    height: calc(100vh - 60px);
    overflow-y: auto;
    padding: 0;
    background-color: rgba(242, 242, 242, 1);
    &.active {
        padding: 0 !important;
    }
    .table_title {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .btn_group {
            margin-top: 42px;
        }
    }

    // table_add_wraoper
    /deep/ .dialog_container {
        .el-dialog__header {
            border-bottom: 1px solid #e5e5e5;
        }
        .el-dialog__body {
            padding-left: 60px;
            padding-right: 60px;
        }
        .dialog_content {
            .el-col {
                text-align: center;
            }
            .el-select {
                .el-input__inner {
                    width: 100%;
                }
            }
            .table_add_wraoper {
                .add_table {
                    margin-top: 24px;
                }
            }
        }
        .el-dialog__footer {
            background: #f5f5f5;
            padding: 8px 15px;
            border-top: 1px solid #e5e5e5;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
        }
    }
    .table_container {
        margin-top: 12px;
    }
}
</style>